/**
 * Контент справки для страницы водителей.
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'drivers',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.drivers.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.drivers.overview',

  // Идентификатор связанного тура
  tourId: 'drivers-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'add-driver',
      questionKey: 'help.pages.drivers.faq.addDriver.question',
      answerKey: 'help.pages.drivers.faq.addDriver.answer',
    },
    {
      id: 'assign-device',
      questionKey: 'help.pages.drivers.faq.assignDevice.question',
      answerKey: 'help.pages.drivers.faq.assignDevice.answer',
    },
    {
      id: 'view-history',
      questionKey: 'help.pages.drivers.faq.viewHistory.question',
      answerKey: 'help.pages.drivers.faq.viewHistory.answer',
    },
    {
      id: 'driver-status',
      questionKey: 'help.pages.drivers.faq.driverStatus.question',
      answerKey: 'help.pages.drivers.faq.driverStatus.answer',
    },
    {
      id: 'driver-photo',
      questionKey: 'help.pages.drivers.faq.driverPhoto.question',
      answerKey: 'help.pages.drivers.faq.driverPhoto.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    addButton: 'help.tooltips.drivers.addButton',
    search: 'help.tooltips.drivers.search',
    statusFilter: 'help.tooltips.drivers.statusFilter',
    driverCard: 'help.tooltips.drivers.driverCard',
    assignDevice: 'help.tooltips.drivers.assignDevice',
  },

  // Связанные туры (для раздела "Другие обзоры")
  relatedTours: ['devices-page', 'trailers-page', 'reports-page'],
}
